import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import { getCharacterCount } from 'src/app/utils/getCharacterCount';
import { CharacterCounter } from 'src/app/v1/views/shared/CharacterCounter';

import { Message } from './components/Message';

import * as styles from './index.css';

interface Props {
  id?: string;
  children?: ReactNode;
  characterLimit?: number;
  helpText?: ReactNode;
  message?: string | null;
  sanitize?: boolean;
  value?: string;
  valid?: boolean;
}

export const TextEditorContainer = ({
  children,
  helpText,
  message,
  value,
  id = 'text-editor-container',
  characterLimit = 0,
  valid = true,
}: Props) => {
  const currentCharacterCount = getCharacterCount(value);

  const hasCharacterLimit = characterLimit > 0;
  const isInvalid =
    !valid || (hasCharacterLimit && currentCharacterCount > characterLimit);
  const messageProps = {
    characterLimit,
    currentCharacterCount,
    id,
    helpText,
    message,
    valid,
  };

  return (
    <>
      <Box className={{ [styles.invalid]: isInvalid }}>{children}</Box>
      {(message || hasCharacterLimit || helpText) && (
        <Box
          position="relative"
          display="flex"
          flexDirection="rowReverse"
          paddingTop="medium"
        >
          {characterLimit > 0 && (
            <Box data-testid="editorCharCounter">
              <CharacterCounter
                currentLength={currentCharacterCount}
                maxLength={characterLimit}
              />
            </Box>
          )}
          <Message {...messageProps} className={styles.information} />
        </Box>
      )}
    </>
  );
};
